import React, { ReactNode } from 'react';
import { useRouter } from 'next/router';
import classNames from 'classnames';
import Tab from '@/components/ui/TabPanel/Tab';

import styles from './TabPanel.module.css';

export type TabsConfig = { path: string, title: ReactNode | undefined }[];

type TabPanelProps = {
  tabsConfig: TabsConfig
};

export default function TabPanel(
  {
    tabsConfig,
  }: TabPanelProps,
): React.ReactElement {
  const { pathname } = useRouter();

  const getTabs = () => tabsConfig.map((tab, index) => (
    <Tab
      href={tab.path}
      isActive={tab.path === pathname}
      key={`tab-item-${index + 1}-${tab.path}`}
    >
      {tab.title}
    </Tab>
  ));

  return (
    <div className={classNames([
      styles['tab-panel'],
    ])}
    >
      {getTabs()}
    </div>
  );
}
